import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  pageEditorModelData: [],
};

const pageEditorModelDataSlice = createSlice({
  name: 'pageEditorModelData',
  initialState,
  reducers: {
    setPageEditorModelData(state, action) {
      // console.log('update appln dtls', action.payload);
      state.pageEditorModelData = action.payload?.pageEditorModelData;
    },
    updateActivePageWidgetList(state, action) {
      //debugger;
      const activePageId = action?.payload?.activePageId;
      const findCurrentPageIndex = state.pageEditorModelData?.findIndex(
        value => value?.pageId === activePageId,
      );
      const newWidgetList = action?.payload?.newWidgetList;
      state.pageEditorModelData[findCurrentPageIndex].pageWidgetDtlsList = newWidgetList;
    },
    updateActivePageWidget(state, action) {
      //debugger;
      const activePageId = action?.payload?.activePageId;
      const activeWidgetId = action?.payload?.widgetId;
      const findCurrentPageIndex = state?.pageEditorModelData?.findIndex(
        value => value?.pageId === activePageId,
      );
      const findCurrentWidgetIndex = state?.pageEditorModelData[
        findCurrentPageIndex
      ]?.pageWidgetDtlsList?.findIndex(value => value?.widgetId === activeWidgetId);
      const newWidget = action?.payload?.newWidget;
      state.pageEditorModelData[findCurrentPageIndex].pageWidgetDtlsList[findCurrentWidgetIndex] =
        newWidget;
    },
    updateActivePageDraftWidget(state, action) {
      //debugger;
      const activePageId = action?.payload?.activePageId;
      const activeWidgetId = action?.payload?.widgetId;
      const findCurrentPageIndex = state?.pageEditorModelData?.findIndex(
        value => value?.pageId === activePageId,
      );
      const findCurrentWidgetIndex = state?.pageEditorModelData[
        findCurrentPageIndex
      ]?.pageWidgetDtlsList?.findIndex(value => value?.widgetId === activeWidgetId);
      const newWidget = action?.payload?.newWidget;
      const newChildOrderWidgetList = action?.payload?.newChildOrderWidgetList;

      state.pageEditorModelData[findCurrentPageIndex].pageChildWidgetOrderList =
        newChildOrderWidgetList;
      state.pageEditorModelData[findCurrentPageIndex].pageWidgetDataDtlsList = state
        ?.pageEditorModelData[findCurrentPageIndex]?.pageWidgetDataDtlsList &&
        action?.payload?.pageWidgetDataDtlsList && [
          ...state?.pageEditorModelData[findCurrentPageIndex]?.pageWidgetDataDtlsList,
          ...action?.payload?.pageWidgetDataDtlsList,
        ];
      state.pageEditorModelData[findCurrentPageIndex].pageWidgetEventsList = state
        ?.pageEditorModelData[findCurrentPageIndex]?.pageWidgetEventsList &&
        action?.payload?.pageWidgetEventsList && [
          ...state?.pageEditorModelData[findCurrentPageIndex]?.pageWidgetEventsList,
          ...action?.payload?.pageWidgetEventsList,
        ];
      state.pageEditorModelData[findCurrentPageIndex].pageWidgetPropsList = state
        ?.pageEditorModelData[findCurrentPageIndex]?.pageWidgetPropsList &&
        action?.payload?.pageWidgetPropsList && [
          ...state?.pageEditorModelData[findCurrentPageIndex]?.pageWidgetPropsList,
          ...action?.payload?.pageWidgetPropsList,
        ];
      state.pageEditorModelData[findCurrentPageIndex].pageWidgetStyleDtlsList = state
        ?.pageEditorModelData[findCurrentPageIndex]?.pageWidgetStyleDtlsList &&
        action?.payload?.pageWidgetStyleDtlsList && [
          ...state?.pageEditorModelData[findCurrentPageIndex]?.pageWidgetStyleDtlsList,
          ...action?.payload?.pageWidgetStyleDtlsList,
        ];
      state.pageEditorModelData[findCurrentPageIndex].pageWidgetDtlsList[
        action?.payload?.position
      ] = newWidget;
    },
    updateActivePageWidgetPropsList(state, action) {
      //debugger;
      const activePageId = action?.payload?.activePageId;
      const findCurrentPageIndex = state.pageEditorModelData?.findIndex(
        value => value?.pageId === activePageId,
      );
      const newWidgetList = action?.payload?.newWidgetList;
      state.pageEditorModelData[findCurrentPageIndex].pageWidgetPropsList = newWidgetList;
    },
    resetPageEditorModelData(state) {
      state.pageEditorModelData = initialState.pageEditorModelData;
    },
    updatePageChildOrderList(state, action) {
      //debugger;
      const activePageId = action?.payload?.activePageId;
      const findCurrentPageIndex = state.pageEditorModelData?.findIndex(
        value => value?.pageId === activePageId,
      );
      state.pageEditorModelData[findCurrentPageIndex].pageChildWidgetOrderList = action?.payload?.pageChildWidgetOrderList;
      state.pageEditorModelData[findCurrentPageIndex].pageChildRestrictedWidgetOrderList = action?.payload?.pageChildRestrictedWidgetOrderList;
    },
    updatePageDetailsById(state, action) {
      //debugger;
      const result = action?.payload?.callBack(JSON.parse(JSON.stringify(state?.pageEditorModelData)));
      const newWidgetList = result?.newWidgetList;
      const latestWidgetNumber = result?.newWidgetList;
      const findCurrentPageIndex = result?.currentPageIndex;
      state.pageEditorModelData[findCurrentPageIndex].latestWidgetNumber = latestWidgetNumber;
      state.pageEditorModelData[findCurrentPageIndex].pageWidgetDtlsList = newWidgetList;
    },
    // updateLatestWidgetNumber(state, action) {
    //   const activePageId = action?.payload?.activePageId;
    //   const findCurrentPageIndex = state.pageEditorModelData?.findIndex(
    //     value => value?.pageId === activePageId,
    //   );
    //   state.pageEditorModelData[findCurrentPageIndex].latestWidgetNumber = action?.payload?.latestWidgetNumber;
    // },
    updatePageDetails(state, action) {
      const activePageId = action?.payload?.activePageId;
      const findCurrentPageIndex = state.pageEditorModelData?.findIndex(
        value => value?.pageId === activePageId,
      );
      const newPageDetails = action?.payload?.newPageDetails || {};
      const newPageDetailsKey = Object.keys(newPageDetails);
      if (newPageDetailsKey && newPageDetailsKey?.length > 0) {
        newPageDetailsKey?.forEach(pageKey => {
          state.pageEditorModelData[findCurrentPageIndex][pageKey] = action?.payload?.newPageDetails[pageKey];
        });
      }
    },

    resetWidgetRspnVal(state, action) {
      const widgetId = action?.payload?.widgetId;
      const pageId = action?.payload?.pageId;
      const parentGrpNameForAppearance = action?.payload?.parentGrpNameForAppearance;
      const parentGrpNameForProp = action?.payload?.parentGrpNameForProp;
      const groupStyleName = action?.payload?.groupStyleName;
      const styleKeyForDevice = action?.payload?.styleKeyForDevice;
      const transformKeyForDevice = action?.payload?.transformKeyForDevice;
      const textstyleKeyForDevice = action?.payload?.textstyleKeyForDevice;
      const fontstyleKeyForDevice = action?.payload?.fontstyleKeyForDevice;
      const pageIndex = state.pageEditorModelData?.findIndex(val => val.pageId === pageId);
      const widgetIndex = state.pageEditorModelData?.[pageIndex]?.pageWidgetPropsList?.findIndex(val => val.id === widgetId);
      state.pageEditorModelData[pageIndex].pageWidgetPropsList[widgetIndex].props[parentGrpNameForAppearance][groupStyleName][styleKeyForDevice] = [];
      state.pageEditorModelData[pageIndex].pageWidgetPropsList[widgetIndex].props[parentGrpNameForAppearance][transformKeyForDevice] = [];
      state.pageEditorModelData[pageIndex].pageWidgetPropsList[widgetIndex].props[parentGrpNameForProp][fontstyleKeyForDevice] = [];
      state.pageEditorModelData[pageIndex].pageWidgetPropsList[widgetIndex].props[parentGrpNameForProp][textstyleKeyForDevice] = [];
      const widgetStyleDtlsKeyForDevice = action?.payload?.widgetStyleDtlsKeyForDevice;
      state.pageEditorModelData[pageIndex].pageWidgetDtlsList[widgetIndex][widgetStyleDtlsKeyForDevice] = [];
    },

    updateWidgetProps(state, action) {
      const widgetProps = action?.payload?.widgetProps
      const parentGrpName = action?.payload?.parentGrpName;
      const groupName = action?.payload?.groupName;
      const widgetId = action?.payload?.widgetId;
      const pageId = action?.payload?.pageId;
      const pageIndex = state.pageEditorModelData?.findIndex(val => val.pageId === pageId)
      const widgetIndex = state.pageEditorModelData?.[pageIndex]?.pageWidgetPropsList?.findIndex(val => val.id === widgetId)
      state.pageEditorModelData[pageIndex].pageWidgetPropsList[widgetIndex].props[parentGrpName][groupName] = widgetProps
      },
      updatePageWidth(state,action){
       const pageList = [...state.pageEditorModelData]
       pageList?.map((page,index)=>{
        state.pageEditorModelData[index].pageWidth=action.payload
       })

    }
  },
});

const { reducer, actions } = pageEditorModelDataSlice;

export const {
  setPageEditorModelData,
  updateActivePageWidgetList,
  updateActivePageWidget,
  updateActivePageDraftWidget,
  updateActivePageWidgetPropsList,
  resetPageEditorModelData,
  updatePageDetailsById,
  updatePageChildOrderList,
  updatePageDetails,
  updateWidgetProps,
  resetWidgetRspnVal,
  updatePageWidth
} = actions;
export default reducer;
